/**
 * @param {import("@prismicio/client").PrismicDocument[]} documents
 */
export function dedupeDocumentsById(documents) {
  if (!Array.isArray(documents)) return [];

  const seen = new Set();
  return documents.filter((doc) => {
    if (!doc?.id || seen.has(doc.id)) return false;
    seen.add(doc.id);
    return true;
  });
}

/**
 * @param {import("@prismicio/client").PrismicDocument} doc
 */
export function docToCardItem(doc) {
  const basePath = doc.type === "property_rental" ? "/location" : "/bien";

  return {
    property: {
      link_type: "Document",
      id: doc.id,
      uid: doc.uid,
      type: doc.type,
      tags: doc.tags ?? [],
      lang: doc.lang,
      slug: doc.slug,
      first_publication_date: doc.first_publication_date,
      last_publication_date: doc.last_publication_date,
      key: doc.id,
      isBroken: false,
      url: `${basePath}/${doc.uid}`,
      data: doc.data,
    },
  };
}
